import { render, staticRenderFns } from "./quotationFreight.vue?vue&type=template&id=a39ca4f4&scoped=true"
import script from "./quotationFreight.vue?vue&type=script&lang=js"
export * from "./quotationFreight.vue?vue&type=script&lang=js"
import style0 from "./quotationFreight.vue?vue&type=style&index=0&id=a39ca4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39ca4f4",
  null
  
)

export default component.exports